import React from "react";
import { Create, SimpleForm, useTranslate, TextInput, Toolbar, SaveButton, required } from "react-admin";
import { makeStyles, CircularProgress } from '@material-ui/core';
import lightTheme from '../layout/themes';
import MyTooltip from '../components/MuiTooltip';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import '../index.css';

const useStyles = makeStyles({
  BlackInput: lightTheme.CommonStyles.CreateAndEdit.BlackInput,
  CardUsersEdit: lightTheme.CardUsersEdit,
  EditToolBar: lightTheme.EditToolBar,
});

const CategoryCreate = props => {
  const classes = useStyles();
  const translate = useTranslate();
  const redirect = () => `/categorys`;

  const CategoryEditToolbar = ({loading, ...props}) => {
    const classes = useStyles();
    return (
      <Toolbar {...props} style={{display: 'flex', justifyContent: 'flex-start'}} className={classes.EditToolBar}>
        <MyTooltip title={<div style={{fontSize: '12px'}}>Crear Categoría</div>} aria-label="Save" arrow placement="right">
          <SaveButton disabled={props.pristine} redirect={`/categorys`} id="GoogleStyleSaveButton" label="Crear" icon={<AddRoundedIcon/>}>
            {loading && (<CircularProgress/>)}
          </SaveButton>
        </MyTooltip>
      </Toolbar>
    )
  };

  return (
    <Create {...props}>
      <SimpleForm redirect={redirect} toolbar={<CategoryEditToolbar/>}>
        <TextInput label={translate('resources.pointOfSale.field.name')} source="name" variant="outlined" 
            multiline="true" fullWidth className={classes.BlackInput} validate={required()}/>
      </SimpleForm>
    </Create>
  )
}; export default CategoryCreate;